import { render, staticRenderFns } from "./HelpWithMyOrderMP.vue?vue&type=template&id=117fe81d&scoped=true"
import script from "./HelpWithMyOrderMP.vue?vue&type=script&lang=js"
export * from "./HelpWithMyOrderMP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117fe81d",
  null
  
)

export default component.exports